function initFundVariantDropdown() {
  const dropdowns = document.querySelectorAll('[data-fund-variant-dropdown]');
  if (!dropdowns.length) return;

  dropdowns.forEach((dropdown) => {
    const trigger = dropdown.querySelector('.fund-variant-dropdown__trigger');
    if (!trigger) return;

    trigger.addEventListener('click', () => {
      const isOpen = dropdown.classList.contains('is-open');
      dropdown.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', !isOpen);
    });
  });

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    dropdowns.forEach((dropdown) => {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove('is-open');
        const trigger = dropdown.querySelector('.fund-variant-dropdown__trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      dropdowns.forEach((dropdown) => {
        if (dropdown.classList.contains('is-open')) {
          dropdown.classList.remove('is-open');
          const trigger = dropdown.querySelector('.fund-variant-dropdown__trigger');
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
            trigger.focus();
          }
        }
      });
    }
  });
}

window.addEventListener('DOMContentLoaded', () => {
  initFundVariantDropdown();
});
